import React, { FC } from 'react'
import styled from 'styled-components'
import { Segment, Grid } from 'semantic-ui-react'
import moment from 'moment'
import { date as dateFormatter, dateTime as dateTimeFormatter } from 'loankeeper-common/helpers/formatters'
import LKGrid from '../../../shared/LKGrid'
import { SegmentGroup, FlexTableChild, TableContainer, GridContainer } from '../../../shared/StyledComponents'
import { constants as DCConstants } from '../../../DetailsContainer'
import { formName, amlOfficersObjectName } from '../../constants'
import { translateCmd } from '../../helpers'
import { useLivedata } from '../../../shared'
import ClientRiskLevelAdd, { ClientRiskLevelAddTrigger } from '../../../ClientRiskLevelAdd'
import { RiskProps } from '../../types'
const WrappedSegmentGroup = styled(SegmentGroup)`
  height: 50% !important;
`

const config = {
  gridIdentity: {
    formName,
    objectName: amlOfficersObjectName,
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnConfigs: {
    Amount: {
      cellStyle: { textAlign: 'right' },
    },
    OperDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    CDate: {
      valueFormatter: ({ value }) => dateTimeFormatter(value),
    },
  },
}

const AMLOfficers: FC<RiskProps> = (props) => {
  //@ts-ignore because the code linked to linkedfile props is commented
  const { ID, data, hash, linkedfiles } = props
  const { amlrecords } = data

  const { OpenDay } = useLivedata('OpenDayStatus.Open_Day as OpenDay')

  const getContextMenu = ({ node: { data } }) => [
    {
      name: translateCmd('entry_details'),
      action: () => {},
      icon: 'info',
      permissionKey: 'LFL_VIEW',
    },
    {
      name: translateCmd('edit_client'),
      icon: 'edit',
      action: () => {},
      permissionKey: 'LFL_VIEW',
    },
    {
      name: translateCmd('delete_risklevel'),
      action: () => {},
      icon: 'delete',
      disabled: moment(data.OperDate).isBefore(moment(OpenDay)),
      permissionKey: 'EDIT_CLIENT_RISKLEVELS',
    },
  ]

  return (
    <WrappedSegmentGroup>
      <SegmentGroup>
        <Segment.Group>
          <FlexTableChild>
            <TableContainer>
              <LKGrid
                rowData={amlrecords}
                getContextMenuItems={getContextMenu}
                {...config}
                instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-AMLOfficers`}
              />
            </TableContainer>
          </FlexTableChild>

          <Segment>
            <GridContainer>
              <Grid>
                <Grid.Row>
                  <Grid.Column textAlign="left" width={16}>
                    {/* @ts-ignore */}
                    <ClientRiskLevelAddTrigger disabled={true}>
                      {translateCmd('add_risklevel')}
                    </ClientRiskLevelAddTrigger>

                    {/* <ClientRiskLevelAdd ID={ID} hash={hash} linkedfiles={linkedfiles} /> */}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </GridContainer>
          </Segment>
        </Segment.Group>
      </SegmentGroup>
    </WrappedSegmentGroup>
  )
}

export default AMLOfficers
